const CART_STATUS = {
  OPEN: "open",
  CLOSED: "closed",
};

const CART_TYPE = {
  CHECKOUT: "checkout",
  FAVORITES: "favorites",
};

const CART_PROCESS_TYPE = {
  NOTHING: "nothing",
  TRANSFER: "transfer",
  RECOVER: "recover",
  MERGE: "merge",
};

module.exports = {
  CART_STATUS,
  CART_TYPE,
  CART_PROCESS_TYPE,
};
